import {Route, Switch, Redirect} from "react-router-dom";
import Stores from "./pages/stores";
import PayResult from "./partials/pay/PayResult";
import MorePages from "./pages/morePages";
import FoodPackage from "./pages/foodPackage";
import MyPack from "./pages/foodPackage/mine";
import Headers from "./partials/headers/Index";
import React from "react";
import Introduced from "./pages/Introduced";
import Intro from "./pages/Intro";
import HandleFooter from "./partials/Footer";

import {useLocation} from "react-router-dom";

const Root = () => {

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();

    return (
        <div>
            <Headers/>
            <Switch>
                <Redirect exact from={'/factors/collectors/:code'} to={'/old/factors/collectors/:code'}/>
                <Redirect exact from={'/factors/customers/:code'} to={'/old/factors/customers/:code'}/>
                <Redirect exact from={'/wallet'} to={`/stores?${query}`} preserveQueryString/>
                <Redirect exact from='/' to={'/stores'}/>
                
                <Route path={'/stores'} component={Stores}/>
                <Route path={'/introduced/:code'} component={Introduced}/>
                <Route path={'/intro'} component={Intro}/>
                <Route path={'/pay-result/:origin/:status'}><PayResult/></Route>
                <Route path={'/more-pages'} component={MorePages}/>
                <Route path={'/food-package/:id'} component={FoodPackage}/>
                <Route path={'/my-food-pack/:id'} component={MyPack}/>

                <Route path={'/fudu'} component={Stores}/>
            </Switch>
            <HandleFooter/>
        </div>
    );
}

export default Root;
